// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-container {
    background: linear-gradient(135deg, #98a2cf 0%, #82788c 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
}

.otp-wrapper {
    width: 100%;
    max-width: 400px;
}

.back-button {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 24px;
    transition: all 0.2s ease;
    backdrop-filter: blur(10px);
}

.back-button:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateX(-2px);
}

.otp-card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.otp-header {
    text-align: center;
    padding: 40px 30px 20px;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.otp-icon {
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    color: white;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%,
    100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

.otp-title {
    font-size: 28px;
    font-weight: 700;
    color: #1a202c;
    margin: 0 0 8px;
}

.otp-description {
    color: #64748b;
    font-size: 16px;
    margin: 0;
    line-height: 1.5;
}

.otp-content {
    padding: 30px;
}

.email-display {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #f1f5f9;
    padding: 12px 16px;
    border-radius: 12px;
    margin-bottom: 30px;
    color: #475569;
    font-size: 14px;
}

.otp-form {
    margin-bottom: 30px;
}

.input-group {
    margin-bottom: 24px;
}

.input-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
}

.otp-input {
    width: 100%;
    height: 56px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    padding: 0 16px;
    font-size: 24px;
    font-family: "Courier New", monospace;
    text-align: center;
    letter-spacing: 8px;
    transition: all 0.2s ease;
    background: #fafafa;
}

.otp-input:focus {
    outline: none;
    border-color: #667eea;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.otp-input::placeholder {
    color: #d1d5db;
    letter-spacing: 4px;
}

.input-hint {
    font-size: 12px;
    color: #9ca3af;
    text-align: center;
    margin-top: 8px;
    margin-bottom: 0;
}

.submit-button {
    width: 100%;
    height: 56px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 12px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
}

.submit-button:hover:not(.disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

.submit-button:active:not(.disabled) {
    transform: translateY(0);
}

.submit-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.loading-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.resend-section {
    text-align: center;
}

.resend-text {
    color: #64748b;
    font-size: 14px;
    margin: 0 0 12px;
}

.resend-button {
    background: none;
    border: none;
    color: #667eea;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
    transition: color 0.2s ease;
}

.resend-button:hover {
    color: #5a67d8;
}

.help-text {
    text-align: center;
    margin-top: 24px;
}

.help-text p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    margin: 0;
}

.help-link {
    color: white;
    text-decoration: underline;
    transition: opacity 0.2s ease;
}

.help-link:hover {
    opacity: 0.8;
}

/* Адаптивность */
@media (max-width: 480px) {
    .otp-container {
        padding: 16px;
    }

    .otp-header {
        padding: 30px 20px 16px;
    }

    .otp-content {
        padding: 20px;
    }

    .otp-title {
        font-size: 24px;
    }

    .otp-input {
        height: 48px;
        font-size: 20px;
        letter-spacing: 6px;
    }

    .submit-button {
        height: 48px;
    }
}

/* Анимация появления элементов */
.email-display {
    animation: fadeInUp 0.6s ease-out 0.2s both;
}

.otp-form {
    animation: fadeInUp 0.6s ease-out 0.4s both;
}

.resend-section {
    animation: fadeInUp 0.6s ease-out 0.6s both;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Эффект фокуса для доступности */
.back-button:focus,
.submit-button:focus,
.resend-button:focus {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: 2px;
}

.otp-input:focus {
    outline: none;
}

/* Состояния для разных длин OTP */
.otp-input[value=""] {
    background: #fafafa;
}

.otp-input:not([value=""]) {
    background: white;
    border-color: #10b981;
}
`, "",{"version":3,"sources":["webpack://./src/components/AccountPage/VerifyOtp.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gFAAgF;AACpF;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,6DAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI;;QAEI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,iCAAiC;AACjC;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,kCAAkC;AAClC;;;IAGI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA,kCAAkC;AAClC;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB","sourcesContent":[".otp-container {\n    background: linear-gradient(135deg, #98a2cf 0%, #82788c 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", sans-serif;\n}\n\n.otp-wrapper {\n    width: 100%;\n    max-width: 400px;\n}\n\n.back-button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(255, 255, 255, 0.1);\n    border: none;\n    color: white;\n    padding: 8px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-bottom: 24px;\n    transition: all 0.2s ease;\n    backdrop-filter: blur(10px);\n}\n\n.back-button:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: translateX(-2px);\n}\n\n.otp-card {\n    background: white;\n    border-radius: 20px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    animation: slideUp 0.6s ease-out;\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.otp-header {\n    text-align: center;\n    padding: 40px 30px 20px;\n    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n.otp-icon {\n    width: 64px;\n    height: 64px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 20px;\n    color: white;\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    0%,\n    100% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.05);\n    }\n}\n\n.otp-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0 0 8px;\n}\n\n.otp-description {\n    color: #64748b;\n    font-size: 16px;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.otp-content {\n    padding: 30px;\n}\n\n.email-display {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    background: #f1f5f9;\n    padding: 12px 16px;\n    border-radius: 12px;\n    margin-bottom: 30px;\n    color: #475569;\n    font-size: 14px;\n}\n\n.otp-form {\n    margin-bottom: 30px;\n}\n\n.input-group {\n    margin-bottom: 24px;\n}\n\n.input-label {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 8px;\n}\n\n.otp-input {\n    width: 100%;\n    height: 56px;\n    border: 2px solid #e5e7eb;\n    border-radius: 12px;\n    padding: 0 16px;\n    font-size: 24px;\n    font-family: \"Courier New\", monospace;\n    text-align: center;\n    letter-spacing: 8px;\n    transition: all 0.2s ease;\n    background: #fafafa;\n}\n\n.otp-input:focus {\n    outline: none;\n    border-color: #667eea;\n    background: white;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.otp-input::placeholder {\n    color: #d1d5db;\n    letter-spacing: 4px;\n}\n\n.input-hint {\n    font-size: 12px;\n    color: #9ca3af;\n    text-align: center;\n    margin-top: 8px;\n    margin-bottom: 0;\n}\n\n.submit-button {\n    width: 100%;\n    height: 56px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border: none;\n    border-radius: 12px;\n    color: white;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.submit-button:hover:not(.disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);\n}\n\n.submit-button:active:not(.disabled) {\n    transform: translateY(0);\n}\n\n.submit-button.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.loading-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top: 2px solid white;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.resend-section {\n    text-align: center;\n}\n\n.resend-text {\n    color: #64748b;\n    font-size: 14px;\n    margin: 0 0 12px;\n}\n\n.resend-button {\n    background: none;\n    border: none;\n    color: #667eea;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    text-decoration: underline;\n    transition: color 0.2s ease;\n}\n\n.resend-button:hover {\n    color: #5a67d8;\n}\n\n.help-text {\n    text-align: center;\n    margin-top: 24px;\n}\n\n.help-text p {\n    color: rgba(255, 255, 255, 0.8);\n    font-size: 12px;\n    margin: 0;\n}\n\n.help-link {\n    color: white;\n    text-decoration: underline;\n    transition: opacity 0.2s ease;\n}\n\n.help-link:hover {\n    opacity: 0.8;\n}\n\n/* Адаптивность */\n@media (max-width: 480px) {\n    .otp-container {\n        padding: 16px;\n    }\n\n    .otp-header {\n        padding: 30px 20px 16px;\n    }\n\n    .otp-content {\n        padding: 20px;\n    }\n\n    .otp-title {\n        font-size: 24px;\n    }\n\n    .otp-input {\n        height: 48px;\n        font-size: 20px;\n        letter-spacing: 6px;\n    }\n\n    .submit-button {\n        height: 48px;\n    }\n}\n\n/* Анимация появления элементов */\n.email-display {\n    animation: fadeInUp 0.6s ease-out 0.2s both;\n}\n\n.otp-form {\n    animation: fadeInUp 0.6s ease-out 0.4s both;\n}\n\n.resend-section {\n    animation: fadeInUp 0.6s ease-out 0.6s both;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Эффект фокуса для доступности */\n.back-button:focus,\n.submit-button:focus,\n.resend-button:focus {\n    outline: 2px solid rgba(255, 255, 255, 0.5);\n    outline-offset: 2px;\n}\n\n.otp-input:focus {\n    outline: none;\n}\n\n/* Состояния для разных длин OTP */\n.otp-input[value=\"\"] {\n    background: #fafafa;\n}\n\n.otp-input:not([value=\"\"]) {\n    background: white;\n    border-color: #10b981;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
